import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { SVGProfile, SVGTreeDots } from "../assets/PackageSVG";
import { AccountMenu } from "./AccountMenu";
import styles from "./UserProfile.module.scss";

export const UserProfile = ({ collapsed = false }: { collapsed?: boolean }) => {
    const { user, isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

    if (isLoading) {
        return <div className={styles.loading}>Loading ...</div>;
    }

    if (!isAuthenticated) {
        return (
            <div className={styles.loginWrapper}>
                <button
                    className={`${styles.loginBtn}${collapsed ? ` ${styles.loginBtnCollapsed}` : ''}`}
                    onClick={() => loginWithRedirect()}
                    type="button"
                >
                    <SVGProfile width="16" height="16" />
                    {!collapsed && 'Log in'}
                </button>
            </div>
        );
    }

    const name = (user?.nickname || user?.name || user?.email || 'User') as string;

    // On the icon rail there is no room for the name row, so the avatar
    // opens the account menu itself, the way the "…" button does when
    // expanded. Both open upward: the card sits at the bottom of the screen.
    if (collapsed) {
        return (
            <div className={styles.wrapperCollapsed}>
                <AccountMenu triggerClassName={styles.avatarBtn} placement="above-start">
                    {user?.picture
                        ? <img className={styles.avatarImg} src={user.picture} alt="" />
                        : <SVGProfile width="18" height="18" />}
                </AccountMenu>
            </div>
        );
    }

    return (
        <div className={styles.card}>
            <div className={styles.left}>
                <span className={styles.icon}>
                    {user?.picture
                        ? <img className={styles.avatarImg} src={user.picture} alt="" />
                        : <SVGProfile width="18" height="18" />}
                </span>
                <span className={styles.text}>
                    <span className={styles.name}>{name}</span>
                    <small className={styles.meta}>Signed in</small>
                </span>
            </div>
            <AccountMenu triggerClassName={styles.dotsBtn} placement="above-end">
                <SVGTreeDots width="14" height="14" />
            </AccountMenu>
        </div>
    );
}
